import React from "react";

function Preloader() {
  return (
    <>
      <div id="preloader">
        <div id="vaanam-preloader" className="vaanam-preloader">
          <div className="animation-preloader">
            <div className="newloader" />
            <div className="txt-loading">
              <span data-text-preloader="V" className="letters-loading">
                V
              </span>
              <span data-text-preloader="A" className="letters-loading">
                A
              </span>
              <span data-text-preloader="A" className="letters-loading">
                A
              </span>
              <span data-text-preloader="N" className="letters-loading">
                N
              </span>
              <span data-text-preloader="A" className="letters-loading">
                A
              </span>
              <span data-text-preloader="M" className="letters-loading">
                M
              </span>
            </div>
          </div>
          <div className="loader">
            <div className="row">
              <div className="col-3 loader-section section-left">
                <div className="bg" />
              </div>
              <div className="col-3 loader-section section-left">
                <div className="bg" />
              </div>
              <div className="col-3 loader-section section-right">
                <div className="bg" />
              </div>
              <div className="col-3 loader-section section-right">
                <div className="bg" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Preloader;
